import React, {Component} from 'react';
import Header from "../../Layouts/Header";
import Toast from "../../Components/Toast";
import API from "../../Services/API";
import {toast} from "react-toastify";

import EmptyPic from "../../Assets/Images/emptypic.png"


class EditProfile extends Component {
    state={
        avatar: null,
        surname: '',
        name: '',
        username: '',
        national_code: '',

        phone: '',
        description: '',

        email: '',
        file: null,
        pic: EmptyPic,

        buttonStatus: "",
        buttonText : "ثبت تغییرات",
        loading: "d-none",
    }
    onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            this.setState({
                pic: reader.result,
                file: event.target.files[0]
            })
        };

    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }

    onButtonClick = () => {
 /*       if(this.state.last_name.length < 3) {
            toast.error('لطفا نام خانوادگی را درست وارد کنید');
            return false
        }*/
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const formData = new FormData();
        const file = this.state.file;
        if (file)
            formData.append('avatar', file);
        formData.append('surname', this.state.surname);
        formData.append('name', this.state.name ? this.state.name : '' );
        formData.append('national_code', this.state.national_code ? this.state.national_code : '' );
        formData.append('phone', this.state.phone);
        if(this.state.email)
            formData.append('email', this.state.email);
/*        formData.append('province_id', this.state.province_id);
        formData.append('city_id', this.state.city_id);*/
        formData.append('device_info', navigator.userAgent);

        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.message);
                const buttonText  = "ثبت تغییرات";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
            })
            .catch((error) => {

                toast.error(error.response.data.user_message);
                const buttonText  = "ثبت تغییرات";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });

            });
    }


    render() {
        return (
            <React.Fragment>
                <Toast/>
                <Header hasBack={true} title='ویرایش پروفایل'  />
                <section className="container rtl  p-3 usual-content mt-4 pt-5 ">
                    <div className="row">
                        <div className="col-12 text-center">
 {/*   <span onClick={this.onExitClick} className='p-2 badge badge-info badge-pill bg-danger'>
        خروج از اپلیکیشن
    </span>*/}
                        </div>
                        <div className="col-12 ">

                            <img alt="Avatar"
                                 src={(this.state.avatar && !this.state.file) ? this.state.avatar : this.state.pic }
                                 width={64} className='rounded-circle'/>
                            <div className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر پروفایل جدید
                                                 <input type="file" onChange={this.onFileChange}
                                                        accept="image/*"
                                                 />
                                                </label>
                                            </div>
                        </div>

                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5"
                                   id="name" name="name"
                                   placeholder="نام"
                                   value={this.state.name}
                                   onChange={this.onInputChange}/>
                            <label htmlFor="name" className="right-0">نام</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5"
                                   id="surname" name="surname"
                                   placeholder="نام خانوادگی"
                                   value={this.state.surname}
                                   onChange={this.onInputChange}/>
                            <label htmlFor="surname" className="right-0">نام خانوادگی</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5 text-left"
                                   id="username" name="username"
                                   placeholder="شماره موبایل"
                                   value={this.state.username.replace('+98','0')}
                                   disabled
                            />
                            <label htmlFor="mobile" className="right-0">شماره موبایل</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="number"
                                   className="form-control px-5"
                                   id="national_code" name="national_code"
                                   placeholder="کد ملی"
                                   value={this.state.national_code ? this.state.national_code : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="national_code" className="right-0">کد ملی</label>
                        </div>
                    </div>
                </section>
                <section className="container rtl mb-5 px-3 usual-content pb-5 ">
                    <div className="row">
                 {/*       <div className="form-floating col-md-6 mt-4">
                            <input type="email"
                                   className="form-control px-5"
                                   id="email" name="email"
                                   placeholder="آدرس ایمیل"
                                   value={this.state.email ? this.state.email : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="email" className="right-0">آدرس ایمیل</label>
                        </div>*/}
                        <div className="form-floating col-md-6 mt-4">
                            <input type="number"
                                   className="form-control px-5"
                                   id="phone" name="phone"
                                   placeholder="شماره تماس ثابت"
                                   value={this.state.phone ? this.state.phone : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="phone" className="right-0">شماره تماس ثابت</label>
                        </div>


                        <div className="col-12 p-2 fixed-bottom max-w-lg">
                            <button
                                className="btn btn-warning text-center  text-semi-big w-100 p-2 pr-4"
                                onClick={this.onButtonClick}
                                disabled={this.state.buttonStatus}
                            >


                                &nbsp;
                                {this.state.buttonText}
                                <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                       aria-hidden="true">

                                </span>

                            </button>
                        </div>



                    </div>
                </section>

            </React.Fragment>
        );
    }
    componentDidMount = () => {

        API.getUserInfo()
            .then((response) => {
                this.setState(response.data.user)
         /*       if (response.results.user.province) {
                    this.setState({
                        province_id: response.results.user.province.id,
                        city_id: response.results.user.city.id
                    })
                }*/

            })
/*        API.provinces(83)
            .then((response) => {
                this.setState({provinces: response.results.provinces})
            })

        API.cities(this.state.province_id)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })*/

    }
}

export default EditProfile;